/* @flow */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BottomNavigation,
  BottomNavigationItem,
} from 'material-ui/BottomNavigation';
import Paper from 'material-ui/Paper';
import HistoryIcon from 'material-ui/svg-icons/action/history';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import { withRouter } from 'react-router-dom';
import type { ContextRouter } from 'react-router';

import { Navbar } from '../../components';
// import Breadcrumb from '../navbar/Breadcrumb';

const styles = {
  container: {
    paddingLeft: 10,
    paddingRight: 10,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
};

const BottomBar = ({
  handleJobRequests,
  handlePendingTutors,
  handleStudents,
}) => (
  <div>
    <Paper zDepth={1}>
      <BottomNavigation>
        <BottomNavigationItem
          label="Open Job Requests"
          icon={<HistoryIcon />}
          onClick={handleJobRequests}
        />
        <BottomNavigationItem
          label="Pending Tutors"
          icon={<HistoryIcon />}
          onClick={handlePendingTutors}
        />
        <BottomNavigationItem
          label="Students"
          icon={<SchoolIcon />}
          onClick={handleStudents}
        />
      </BottomNavigation>
    </Paper>
  </div>
);

type Props = {
  authenticated: boolean,
  children: any,
  handleLogout: () => void,
} & ContextRouter;

class Root extends Component<Props> {
  handlePendingTutors = () => {
    this.props.history.push({
      pathname: '/admin/tutor',
      state: {
        status: 'Pending',
        hasDocuments: true,
      },
    });
  };

  handleJobRequests = () => {
    this.props.history.push({
      pathname: '/admin/job-request',
      state: {
        status: 'Open',
        hasOpenJobOffers: true,
      },
    });
  };

  handleStudents = () => {
    this.props.history.push('/admin/student');
  };

  render() {
    const { history, location, authenticated } = this.props;

    return (
      <div style={styles.root}>
        <Navbar history={history} />
        {/* <Breadcrumb routes={routes} params={params} /> */}
        <div style={styles.container}>{this.props.children}</div>
        {location.pathname === '/' && authenticated ? (
          <BottomBar
            handlePendingTutors={this.handlePendingTutors}
            handleStudents={this.handleStudents}
            handleJobRequests={this.handleJobRequests}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  username: state.auth.username,
});

// $FlowFixMe
export default withRouter(connect(mapStateToProps)(Root));



// WEBPACK FOOTER //
// ./src/components/root/Root.js